/** BeeDigital whitelabel theme entry. */

import type { WhitelabelThemeEntry } from '../../types';
import { beedigitalDefaultTheme } from './default';

export { beedigitalWhitelabel } from './default';

export const beedigitalWhitelabelThemeEntry: WhitelabelThemeEntry = {
  themes: {
    default: beedigitalDefaultTheme,
  },
};
